import { useEffect } from "react"
import { Navigate, Route, Routes } from "react-router-dom"

import { useWatchlistInstruments } from "@/App/Equities/shared/services/watchlist"
import { useLayoutContext } from "@/App/useLayoutContext"
import { ROUTES_CONFIG } from "@/constants"
import { Stack } from "@/generated/material"
import { withSubscribe } from "@/utils/withSubscribe"

import { AccountSummary } from "./components/AccountSummary"
import { Trade } from "./components/Trade"

export const DesktopRoutes = withSubscribe(() => {
  const instruments = useWatchlistInstruments()
  const { setHeaderExtra } = useLayoutContext()

  useEffect(() => {
    setHeaderExtra(<AccountSummary />)
    return () => setHeaderExtra(null)
  }, [setHeaderExtra])

  return (
    <>
      <Stack flex={1}>
        <Routes>
          <Route
            path="/*"
            element={
              <Navigate
                to={ROUTES_CONFIG.tradeInstrument(
                  instruments[0]?.symbol || "AAPL",
                )}
                replace
              />
            }
          />
          <Route key="/trade" path="/trade/*" element={<Trade />} />
        </Routes>
      </Stack>
    </>
  )
})
